"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCandyGuardDataSerializer = void 0;
const serializers_1 = require("@metaplex-foundation/umi/serializers");
const guards_1 = require("../guards");
function getCandyGuardDataSerializer(context, program) {
    return (0, serializers_1.struct)([
        ['guards', (0, guards_1.getGuardSetSerializer)(context, program)],
        ['groups', (0, serializers_1.array)((0, guards_1.getGuardGroupSerializer)(context, program))],
    ], { description: 'CandyGuardData' });
}
exports.getCandyGuardDataSerializer = getCandyGuardDataSerializer;
//# sourceMappingURL=candyGuardData.js.map